import { Box } from "@storyofams/react-ui";
import { Button } from "~components/common/Button";

export const QuantityInput = ({ quantity, setQuantity }) => {
  return (
    <Box>
      <Box
        px={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        height="56px"
        width={["78px", "91px"]}
        border="1px solid grey200"
        borderRadius="md"
        backgroundColor="white"
      >
        <Button
          variant="unstyled"
          fontSize="18px"
          customPX={0}
          customPY={0}
          fontWeight={500}
          color="grey400"
          width="15px"
          disabled={quantity < 2}
          onClick={() => {
            setQuantity((value) => --value);
          }}
        >
          -
        </Button>
        <Box
          width="20px"
          as="input"
          textAlign="center"
          type="number"
          fontFamily="Barlow"
          fontSize="18px"
          fontWeight={500}
          border="none"
          value={quantity}
          onChange={(event) => {
            setQuantity(Number(event.target.value));
          }}
        />
        <Button
          color="grey400"
          textAlign="end"
          width="15px"
          variant="unstyled"
          fontSize="18px"
          fontWeight={500}
          customPX={0}
          customPY={0}
          onClick={() => {
            setQuantity((value) => ++value);
          }}
        >
          +
        </Button>
      </Box>
    </Box>
  );
};
